export default "__VITE_PUBLIC_ASSET__09cd6cd9__"